import React, { Component } from 'react'
import Swiper from 'react-id-swiper'
import 'react-id-swiper/lib/styles/css/swiper.css'

import { clients } from '../../data/clients'

export default class Navigation extends Component {
  render() {
    const params = {
      slidesPerView: 6,
      spaceBetween: 30,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
      },
      clickable: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        1024: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        320: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
      },
    }

    return (
      <Swiper {...params}>
        {clients.map((client) => (
          <div key={client.key} className="swiper-slide">
            <div
              className="testimonial-content"
              style={{
                backgroundColor: client.bg ? 'rgba(0,0,0,0.7)' : 'transparent',
                borderRadius: '12px', // optional, if you want rounded edges
              }}
            >
              <div className="content">
                <a
                  href={client.link || '#'}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={client.img}
                    className="img-fluid grayscale"
                    alt={client.alt}
                  />
                </a>
              </div>
            </div>
          </div>
        ))}
      </Swiper>
    )
  }
}
